import { render, staticRenderFns } from "./applicantInfo.vue?vue&type=template&id=a36a4dfa&scoped=true"
import script from "./applicantInfo.vue?vue&type=script&lang=js"
export * from "./applicantInfo.vue?vue&type=script&lang=js"
import style0 from "./applicantInfo.vue?vue&type=style&index=0&id=a36a4dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36a4dfa",
  null
  
)

export default component.exports